<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

function handleLogout() {
  router.push('/auth')
}
</script>

<template>
  <div class="max-w-2xl mx-auto space-y-6">
    <h2 class="text-xl font-display font-bold text-text-primary">设置</h2>

    <!-- 账户信息 -->
    <div class="bg-bg-surface rounded-lg p-6 border border-accent-purple border-opacity-20">
      <h3 class="text-text-primary font-medium mb-4">账户信息</h3>
      <div class="space-y-4">
        <div>
          <label class="block text-text-muted text-xs mb-1">用户名</label>
          <input
            type="text"
            value="demo_user"
            disabled
            class="w-full bg-bg-base border border-bg-elevated rounded-md px-3 py-2 text-text-disabled text-sm"
          />
        </div>
        <p class="text-text-disabled text-xs">当前为 UI Demo，账户系统尚未接入后端</p>
      </div>
    </div>

    <!-- 存档管理 -->
    <div class="bg-bg-surface rounded-lg p-6 border border-accent-purple border-opacity-20">
      <h3 class="text-text-primary font-medium mb-4">存档管理</h3>
      <div class="space-y-3">
        <div class="flex items-center justify-between p-3 bg-bg-base rounded-md">
          <div>
            <p class="text-text-secondary text-sm">自动存档</p>
            <p class="text-text-muted text-xs">第1年4月 Week2</p>
          </div>
          <button class="px-3 py-1.5 border border-bg-elevated text-text-muted text-xs rounded hover:border-accent-purple transition-colors">
            读取
          </button>
        </div>
        <div class="flex gap-2">
          <button class="flex-1 py-2 border border-bg-elevated text-text-muted text-sm rounded-md hover:border-accent-purple transition-colors">
            手动存档
          </button>
          <button class="flex-1 py-2 border border-bg-elevated text-text-muted text-sm rounded-md hover:border-accent-purple transition-colors">
            导出存档
          </button>
        </div>
      </div>
    </div>

    <!-- 游戏设置 -->
    <div class="bg-bg-surface rounded-lg p-6 border border-accent-purple border-opacity-20">
      <h3 class="text-text-primary font-medium mb-4">游戏设置</h3>
      <div class="space-y-4">
        <div class="flex items-center justify-between">
          <span class="text-text-secondary text-sm">背景音乐</span>
          <button class="w-12 h-6 bg-primary rounded-full relative">
            <span class="absolute right-1 top-1 w-4 h-4 bg-white rounded-full"></span>
          </button>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-text-secondary text-sm">音效</span>
          <button class="w-12 h-6 bg-primary rounded-full relative">
            <span class="absolute right-1 top-1 w-4 h-4 bg-white rounded-full"></span>
          </button>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-text-secondary text-sm">动画效果</span>
          <button class="w-12 h-6 bg-bg-elevated rounded-full relative">
            <span class="absolute left-1 top-1 w-4 h-4 bg-text-muted rounded-full"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- 关于 -->
    <div class="bg-bg-surface rounded-lg p-6 border border-accent-purple border-opacity-20">
      <h3 class="text-text-primary font-medium mb-4">关于</h3>
      <div class="text-text-muted text-sm space-y-2">
        <p>地下偶像事务所 v0.1.0</p>
        <p>UI Demo · Phase 0-B</p>
        <p class="text-xs text-text-disabled mt-4">© 2026 暗星制作</p>
      </div>
    </div>

    <!-- 退出登录 -->
    <button
      @click="handleLogout"
      class="w-full py-3 border border-danger border-opacity-30 text-danger text-sm rounded-md hover:bg-danger hover:bg-opacity-10 transition-colors"
    >
      退出登录
    </button>
  </div>
</template>
